<template>
  <div id="bars">
    <div class="content">
      <ul>
        <li>
          <mal-nav></mal-nav>
        </li>
        <li class="li">
          <div :class="{tabselect:selectSelf,tabunselect:!selectSelf}" @click="showSelf" ref="self">
            <a href="javascript:void(0)">{{constant.self}}</a>
          </div>
        </li>
        <li class="li" v-if="isShowJd">
          <div :class="{tabselect:!selectSelf,tabunselect:selectSelf}" @click="showJd">
            <a href="javascript:void(0)">{{constant.jd}}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Nav from "./Nav.vue";
export default {
  components: {
    "mal-nav": Nav
  },
  data: function() {
    let selfProducts = this.$store.state.malMainPageConfig.categoryGoodsShow.categoryGoods.slice(
      0
    );
    let isShowJd = this.$store.state.malMainPageConfig.source.isShowJd;
    return {
      selectSelf: true,
      isShowJd : isShowJd,
      selfProducts: selfProducts, //cache self
      jdProducts: [], //cache jd
      selfNav: {}, //缓存自建分类
      jdNav: {}, //缓存京东分类
      constant: this.$store.state.malMainPageConfig.constant
    };
  },
  created() {
    if (this.$store.state.source == 2) {
      this.showJd();
    }
  },
  methods: {
    showNav(isShow) {
      if (this.isShowAlways) {
        //分类导航栏一直显示
        this.isShowNav = this.isShowAlways;
      } else {
        this.isShowNav = isShow;
      }
    },

    /*显示自建商城*/
    showSelf() {
      this.$store.commit({
        type: "updateSource",
        source: "1"
      });
      this.$store.commit({
        type: "updateCategoryGoodsLoading",
        loading: true
      });
      this.selectSelf = true;
      let malMainPageConfig = this.$store.state.malMainPageConfig;
      malMainPageConfig.isShowSelf = true;
      //加载分类商品
      let categoryGoods = this.selfProducts.slice(0);
      malMainPageConfig.categoryGoodsShow.categoryGoods = categoryGoods;
      //加载分类导航栏
      if (this.selfNav.navItems) {
        malMainPageConfig.nav = this.selfNav;
        this.$store.commit({
          type: "updateMalMainPageConfig",
          malMainPageConfig: malMainPageConfig
        });
        this.$store.commit({
          type: "updateCategoryGoodsLoading",
          loading: false
        });
      } else {
        this.$api.mainpageApi.getNavJo("1").then(response => {
          let navJo = response.data.data;
          this.selfNav = navJo;
          malMainPageConfig.nav = navJo;
          this.$store.commit({
            type: "updateMalMainPageConfig",
            malMainPageConfig: malMainPageConfig
          });
          this.$store.commit({
            type: "updateCategoryGoodsLoading",
            loading: false
          });
        });
      }
    },
    /*显示京东商城*/
    showJd() {
      this.$store.commit({
        type: "updateCategoryGoodsLoading",
        loading: true
      });
      //改变商城来源
      this.$store.commit({
        type: "updateSource",
        source: "2"
      });
      this.selectSelf = false;
      let malMainPageConfig = this.$store.state.malMainPageConfig;
      let categoryGoods = malMainPageConfig.categoryGoodsShow.categoryGoods;
      //隐藏促销组件和品质店铺
      malMainPageConfig.isShowSelf = false;
      //先清空分类商品
      categoryGoods.splice(0, categoryGoods.length);
      //加载分类导航栏
      //如果存在缓存
      if (this.jdNav.navItems) {
        malMainPageConfig.nav = this.jdNav;
        //从缓存中取分类商品
        if (this.jdProducts.length > 0) {
          categoryGoods = this.jdProducts.slice(0);
          malMainPageConfig.categoryGoodsShow.categoryGoods = categoryGoods;
          this.$store.commit({
            type: "updateMalMainPageConfig",
            malMainPageConfig: malMainPageConfig
          });
          this.$store.commit({
            type: "updateCategoryGoodsLoading",
            loading: false
          });
        } else {
          //从接口取分类商品
          this.$api.mainpageApi
            .loadJdProducts()
            .then(response => {
              this.jdProducts = response.data.data;
               if (this.$store.state.source == "2") {
                  categoryGoods = this.jdProducts.slice(0);
                  malMainPageConfig.categoryGoodsShow.categoryGoods = categoryGoods;
                  this.$store.commit({
                    type: "updateMalMainPageConfig",
                    malMainPageConfig: malMainPageConfig
                  });
               }
              this.$store.commit({
                type: "updateCategoryGoodsLoading",
                loading: false
              });
            })
            .catch(error => {
              this.$store.commit({
                type: "updateCategoryGoodsLoading",
                loading: false
              });
            });
        }
      } else {
        this.$api.mainpageApi.getNavJo("2").then(navresponse => {
          let navJo = navresponse.data.data;
          this.jdNav = navJo;
          
          malMainPageConfig.nav = navJo;

          malMainPageConfig.categoryGoodsShow.categoryGoods = categoryGoods;

          //判断当前商城来源，避免将京东的数据渲染到自建中去
          if (this.$store.state.source == "2") {
              this.$store.commit({
              type: "updateMalMainPageConfig",
              malMainPageConfig: malMainPageConfig
            });
          }
          
          //从缓存中取分类商品
          if (this.jdProducts.length > 0) {
            categoryGoods = this.jdProducts.slice(0);
            malMainPageConfig.categoryGoodsShow.categoryGoods = categoryGoods;
            this.$store.commit({
              type: "updateMalMainPageConfig",
              malMainPageConfig: malMainPageConfig
            });
            this.$store.commit({
              type: "updateCategoryGoodsLoading",
              loading: false
            });
          } else {
            //从接口取分类商品
            this.$api.mainpageApi
              .loadJdProducts()
              .then(response => {
                this.jdProducts = response.data.data;
                //判断当前商城来源，避免将京东的数据渲染到自建中去
                if (this.$store.state.source == "2") {
                    categoryGoods = this.jdProducts.slice(0);
                    malMainPageConfig.categoryGoodsShow.categoryGoods = categoryGoods;
                    this.$store.commit({
                    type: "updateMalMainPageConfig",
                    malMainPageConfig: malMainPageConfig
                  });
                }
                this.$store.commit({
                  type: "updateCategoryGoodsLoading",
                  loading: false
                });
              })
              .catch(error => {
                this.$store.commit({
                  type: "updateCategoryGoodsLoading",
                  loading: false
                });
              });
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
#bars {
  width: 100%;
  height: 44px;
  border-bottom: 1px solid #f98354;
  background-color: #fff;
}
#bars .content {
  width: 1200px;
  height: 44px;
  margin: 0 auto;
}
* {
  margin: 0;
  padding: 0;
}
div {
  display: block;
}
.content > ul > li {
  float: left;
  height: 44px;
  line-height: 44px;
  padding: 0 20px 0 0;
  font-size: 15px;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
// .content li a{
//   color : black
// }
.c_left a {
  padding: 0 2px;
  cursor: pointer;
}

.c_left ul {
  padding: 15px 0;
}
.c_left li {
  width: 200px;
  height: 20px;
  padding: 5px 0 5px 10px;
  position: relative;
}

.c_left li p {
  float: left;
  width: 180px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  position: absolute;
}
/*轮播图左边第一个二级菜单*/
.c_left .box .bx_a .case1 a {
  padding: 3px 10px;
  margin-right: 7px;
  background-color: #6e6568;
}
.c_left .box .bx_a .case1 a:hover {
  background-color: #5c5251;
}
.c_left .box .bx_a .case2 h5 {
  float: left;
  width: 70px;
  height: 41px;
  line-height: 41px;
  text-align: right;
}
.c_left .box .bx_a .case2 a {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 7px 0 0;
}
.c_left .box .bx_a .case2 a:hover {
  color: #c94e4a;
}
/*轮播图左边第一个二级菜单END*/

.c_left li:hover {
  background-color: #999395;
}
.c_left p a:hover {
  color: #c81623;
}

.c_left .box .bx_a .case1 a {
  padding: 3px 10px;
  margin-right: 7px;
  background-color: #6e6568;
}
.tabselect {
  height: 41px;
  color: #f98354;
  border-bottom: 3px #f98354 solid;
}

.tabunselect {
  height: 41px;
  border: 0px;
  color: black;
}

.tabselect a {
  color: #f98354;
}

.tabunselect a {
  color: black;
}
</style>
